import React from "react";
import brandLogo from "../../assets/parkingHeroLogo.svg";
import "./styles.scss";
import { useLocation } from "react-router-dom";

export const IncidentDetailsPage: React.FC = () => {
    const location:any=useLocation()
    console.log(location)
    return (
        <>
            <div className="incident-details-page">
                <div className="logo-wrapper">
                    <img src={brandLogo} alt="" />
                </div>
                <br />
                <div className="heading">
                    <h1 className="heading-text">Incident Details</h1>
                </div>

                <div className="space"></div>

                <div className="main-container">
                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Date:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">03/02/2022</p>
                            {/* <p className="value-text">{"03/02/2022"}</p> */}
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Time:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">01:35 PM ET</p>
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Incident Type:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">{location.state.incident_details.toString()}</p>
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Location:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">Grandiose Drive Indianapolis</p>
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Status:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">active</p>
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Attachments:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">{location.state.attachments}</p>
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="field-container">
                        <div className="label basis-1/2">
                            <p className="label-text">Incident Reported by You:</p>
                        </div>
                        <div className="value basis-1/2">
                            <p className="value-text">Yes</p>
                        </div>
                    </div>

                    <p className="white-line"></p>

                    <div className="space"></div>

                </div>
            </div>
        </>
    )
}
